import Image from "next/image";
import Link from "next/link";
import React from "react";

const BlogCard = ({ blog }) => {
  const baseUrl = `${process.env.NEXT_PUBLIC_CDN}/uploads`;
  return (
    <div className="flex flex-col rounded-custom-30 bg-blogsBgColor p-3 flex-shrink-0 lg:w-auto xsm:w-[458px] w-[300px]">
      <Link
        title={blog.title}
        href={blog.url ?? ""}
        prefetch={false}
        className="flex rounded-custom-20 overflow-hidden"
      >
        <Image
          src={`${baseUrl}/${blog.resim}`}
          width={433}
          height={277}
          alt="blog"
          sizes="(max-width: 1280px) 100vw,
             33vw"
          className="object-cover lg:w-full h-52 md:h-96 xl:h-64 transition-all duration-300 hover:scale-110"
        />
      </Link>
      <div className="flex flex-col items-start gap-4 rounded-custom-10 bg-white sm:py-5 py-2 sm:px-6 px-3 sm:mx-4 mx-1 sm:-mt-10 -mt-5 sm:mb-6 mb-3 z-10">
        <div className="flex items-center gap-2">
          <Image
            src="/icons/times.svg"
            width={20}
            height={20}
            alt="times"
            className="object-contain"
          />
          <span className="text-themeBlack text-opacity-50 text-size-13 font-normal leading-5">
            {blog.tarih}
          </span>
        </div>
        <span className="text-themeBlack text-base font-medium leading-5">
          {blog.kisa_baslik}
        </span>
        <span className="text-themeBlack text-opacity-50 text-size-13">
          {blog.kisa_icerik}
        </span>
      </div>
      <Link
        title={blog.title}
        href={blog.url ?? ""}
        prefetch={false}
        className="text-themeBlack text-opacity-50 block text-center text-sm font-medium mb-2"
      >
        Devamını oku
      </Link>
    </div>
  );
};

export default BlogCard;
